// extracted by mini-css-extract-plugin
export var growableInput = "_6b-0";
export var tagContainer = "_6b-2";
export var textInput = "_6b-1";